import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
// data
import onEventFaqSubmit from './data/onEventFaqSubmit';
import { eventFaqDefinition } from '../shared-components/faq/data/eventFaqDefinition';
import { EVENT_FAQ_CONST, RESTROOM_FORM } from '../shared-components/faq/data/constants';
import { onEventFaqBlur, onEventFaqChange } from './data/onEventFaqChange';
import { hasQuantityAndDescription, mapBoolToString, pageInfo, seedValuesWithSelected } from './data/utils';
// faq component
import ButtonNavigation from '../app-faq-components/ButtonNavigation';
import ToggleFieldRow from '../app-faq-components/ToggleFieldRow';
import FaqHeader from '../app-faq-components/FaqHeader';

const { STANDARD_RESTROOMS, ADA_RESTROOMS, NURSING_ROOMS } = EVENT_FAQ_CONST;

FaqHeader.propTypes = { header: PropTypes.any };
const RestroomForm = ({
  error,
  handleSubmit,
  intl,
  page,
  eventFaq,
  dispatch,
  spaceId,
  accessToken,
  showErrorToast,
  ...props
}) => {
  const header = intl.formatMessage(pageInfo(page).header);
  const Icon = pageInfo(page).icon;
  const restrooms = get(eventFaqDefinition, 'restroom', {});
  const onChangeFn = onEventFaqChange(dispatch, spaceId, accessToken, showErrorToast);
  const onBlurFn = onEventFaqBlur(dispatch, spaceId, accessToken, showErrorToast);
  return (
    <form className="flex-basis-100" onSubmit={handleSubmit}>
      <FaqHeader header={header} icon={<Icon />} />
      <h6 className="questions-section">
        <FormattedMessage
          id="hosting.restroom_form.restroom_facilities"
          defaultMessage="Restrooms and facilities"
        />
      </h6>
      {
        Object.keys(restrooms)
          .map((key) => (
            <>
              <ToggleFieldRow
                label={restrooms[key]}
                selected
                formName={RESTROOM_FORM}
                fieldName={key}
                dispatch={dispatch}
                tooltip={restrooms[key].tooltip}
                hasQuantity={props[`${key}_quantity`]}
                hasDescription={props[`${key}_description`]}
                onChange={onChangeFn}
                onBlur={onBlurFn}
              />
              <hr/>
            </>
          ))
      }
      <div className="text-danger text-small margin-xl-bottom">{error}</div>
      <ButtonNavigation {...props} dispatch={dispatch} spaceId={spaceId} />
    </form>
  );
};

RestroomForm.propTypes = {
  handleSubmit: PropTypes.func,
  error: PropTypes.string,
  dispatch: PropTypes.func,
  parkingToggleFieldValue: PropTypes.string,
  intl: intlShape,
  eventFaq: PropTypes.object,
  spaceId: PropTypes.string,
  accessToken: PropTypes.string,
  showErrorToast: PropTypes.bool,
  page: PropTypes.string
};

const config = {
  form: RESTROOM_FORM,
  onSubmit: onEventFaqSubmit
};

const selector = formValueSelector(RESTROOM_FORM);
function mapStateToProps (state, { eventFaq }) {
  const fields = [
    STANDARD_RESTROOMS,
    ADA_RESTROOMS,
    NURSING_ROOMS
  ];
  const initialValues = {
    ...mapBoolToString(seedValuesWithSelected(eventFaq))
  };
  const itemSelected = hasQuantityAndDescription(fields, selector, state);
  return {
    ...itemSelected,
    initialValues
  };
}

export default connect(mapStateToProps)(reduxForm(config)(injectIntl(RestroomForm)));
